(function() {
    'use strict';

    var module = angular.module('app');

    module.directive(
        'header',
        [
            function() {
                return {
                    restrict: 'E',
                    scope: {},
                    templateUrl: '/app/features/header/header.tpl.html',
                    controller: 'headerCtrl',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]);

    module.controller(
        'headerCtrl',
        [
            'authenticationEvents', 'bus', '$scope', 'currentUserService',
            function(authenticationEvents, bus, $scope, currentUserService) {
                var vm = this;
                vm.isLoggedIn = !!(currentUserService.getCurrentUser());

                bus.subscribe(
                    authenticationEvents.loginSuccess,
                    function() {
                        vm.isLoggedIn = true;
                    },
                    $scope);

                bus.subscribe(
                    authenticationEvents.logoutSuccess,
                    function() {
                        vm.isLoggedIn = false;
                    },
                    $scope);
            }
        ]);
}());